import { useSelector } from "react-redux";
import handleCloseWidget from "../../helper/handleCloseWidget";
import { selectClientConfig } from "../clientContext";
import { URLEndPoint } from "./ExitFlow.constants";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { selectAccessToken } from "../accessTokens";
import { Button } from "react-bootstrap";
import { CLASS, COMMODITIES_LIST, UNITS, selectPortalSetting, selectPrice } from "../GetPrice";
import { BOUNDARIES } from "../ContactMeView/contactme_constants";
import { REACT_APP_API_URL } from "../../infrastructure/http/http.constants";
import { selectFilledFieldsInInfo, selectSelectedSupplier} from "../PriceAndCustomerDetails";

export const ExitFlow = () => {
    const clientConfig = useSelector(selectClientConfig);
    const accessToken = useSelector(selectAccessToken);
    const basicInfo = useSelector(selectPrice);
    const portalSettings = useSelector(selectPortalSetting);
    const filledFieldsInInfo=useSelector(selectFilledFieldsInInfo);
    const selectedSupplier = useSelector(selectSelectedSupplier);


    const dispatch = useDispatch();
    const history = useHistory();
    const authKey = clientConfig.authKey;
    const brokerageId = clientConfig.brokerageId;
    const selectedClass = basicInfo.class || portalSettings.defaultClass || "";
    const usage = parseInt(typeof basicInfo.usage === "string" ? basicInfo.usage.replace(",", "") : basicInfo) || (selectedClass === CLASS.RESIDENTIAL ? portalSettings.defaultValueResiElectric : portalSettings.defaultValueCommElectric) ||0;


    //EVALUATE LEAD LEVEL 
    const selectBoundary = () => {
        const { mediumBoundaryMin, largeBoundaryMin, smallBoundaryMin, smallBoundaryMax, mediumBoundaryMax, largeBoundaryMax } = portalSettings;
        const { smallBoundaryMinElectric, smallBoundaryMaxElectric, mediumBoundaryMinElectric, mediumBoundaryMaxElectric, largeBoundaryMinElectric, largeBoundaryMaxElectric } = portalSettings;
        const { smallBoundaryMinGas, smallBoundaryMaxGas, mediumBoundaryMinGas, mediumBoundaryMaxGas, largeBoundaryMinGas, largeBoundaryMaxGas } = portalSettings;
         
        if(!selectedClass){return BOUNDARIES[0]}
        else if (selectedClass  === CLASS.RESIDENTIAL) { return BOUNDARIES[1] }
        else if ((usage >= smallBoundaryMin && usage <= smallBoundaryMax) ||
            (usage >= smallBoundaryMinElectric && usage <= smallBoundaryMaxElectric) ||
            (usage >= smallBoundaryMinGas && usage <= smallBoundaryMaxGas)) { return BOUNDARIES[2] }
        else if ((usage >= mediumBoundaryMin && usage <= mediumBoundaryMax) ||
            (usage >= mediumBoundaryMinElectric && usage <= mediumBoundaryMaxElectric) ||
            (usage >= mediumBoundaryMinGas && usage <= mediumBoundaryMaxGas)) { return BOUNDARIES[3] }
        else if ((usage >= largeBoundaryMin && usage <= largeBoundaryMax) ||
            (usage >= largeBoundaryMinElectric && usage <= largeBoundaryMaxElectric) ||
            (usage >= largeBoundaryMinGas && usage <= largeBoundaryMaxGas)) { return BOUNDARIES[4]}
    }
    const typeBoundary = selectBoundary();
    //FETCH REF CODE DATA
    const refCodeData = portalSettings.referrals.find(i => i.referralCode.toLowerCase() === (basicInfo.referralCode ? basicInfo.referralCode.toLowerCase() : "default") )   

    //CREATE PAYLOAD    
    const payload = {
        "BrokerId": brokerageId,
         "contact": {
            "firstName": filledFieldsInInfo?.firstName || "",
            "lastName": filledFieldsInInfo?.lastName || "",
            "email": filledFieldsInInfo?.email || "",
            "personalPhone" : filledFieldsInInfo?.personalPhone || "",
            "workPhone" : filledFieldsInInfo?.workPhone ? filledFieldsInInfo?.workPhone  : (filledFieldsInInfo?.personalPhone || ""),
            "billingAddress": {
                "address": filledFieldsInInfo?.billingAddress || "",
          
                "city": filledFieldsInInfo?.billingCity || "",
          
                "stateId": filledFieldsInInfo?.billingStateId || "",
          
                "zipCode": filledFieldsInInfo?.billingZipCode || ""
              }, 
        },
        "meters": [[
            {
                "utilityId": selectedSupplier.LDCId,
                "accountNumber": filledFieldsInInfo?.accountNumber,
                "serviceAddress": {
                    "address": filledFieldsInInfo?.serviceAddress,
                    "city": filledFieldsInInfo?.serviceAddressCity,
                    "stateId": filledFieldsInInfo?.serviceAddressStateId,
                    "zipCode": filledFieldsInInfo?.serviceAddressZipCode
                }
            }
        ]],
        "CustomerLegalEntityName": filledFieldsInInfo?.customerLegalEntityName || "", // Commercial only
        "CustomerDealLevelName": typeBoundary.name,
        "CustomerDealLevelId": typeBoundary.id,
        "class": basicInfo.class,
        "CommodityName": COMMODITIES_LIST[basicInfo.commodity],
        "commodityTypeId": basicInfo.commodity,
        "ZipCode": basicInfo.ZipCode,
        "StateName": basicInfo?.state?.displayName || "",
        "StateId": basicInfo?.state?.id,
        "PromoCode": basicInfo.referralCode,
        "salesPersonName" : refCodeData.salesPersonName,
        "salesPersonId" : refCodeData.salesPersonId,
        "AnnualUsageOrMonthlyBill": basicInfo.usage,
        "Unit": COMMODITIES_LIST[basicInfo.commodity || portalSettings.defaultCommodityId] === "Electric" ? UNITS.KWH : COMMODITIES_LIST[basicInfo.commodity || portalSettings.defaultCommodityId] === "NatGas" && UNITS.TH,
        "brokernumber": portalSettings.companyId
    }


    //LEAD CREATION API 
    const createLeadAPI = async (payload) => {
        try {
        await fetch(`${REACT_APP_API_URL}/${URLEndPoint}` + `${authKey}`, {
            method: 'POST',
            headers: {
                "Authorization": "Bearer " + accessToken,
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(payload)

        }).then(res => res.json())
            .then(data => {
              handleCloseWidget(dispatch,history,clientConfig.client);
            })
        } 
        catch (error) {
            console.log(error);
            handleCloseWidget(dispatch,history,clientConfig.client);
        }
    }

    
    return (
    <Button
      variant="outline-light"
      onClick={() => {
        //CLOSE WIDGET IF CLASS IS COMMERCIAL AND COMPANY NAME, FIRST NAME OR LAST NAME IS NA
        if((!payload.contact.firstName || !payload.contact.lastName) || (basicInfo.class === CLASS.COMMERCIAL && !payload.CustomerLegalEntityName)){
            handleCloseWidget(dispatch, history, clientConfig.client);
            return;
        }
        // CALL THE API AND CLOSE THE WIDGET
        createLeadAPI(payload);
      }}
    >
      <i className="fa fa-times fa-2x f-20"></i>
    </Button>
    );
}
